import { useAuthStore, useBranchesStore, useGeneralStore } from 'src/stores'

const authStore = useAuthStore()
const branchesStore = useBranchesStore()
const generalStore = useGeneralStore()

function logout() {
  authStore.$reset()

  // @Kaveh
  authStore.$state = {
    token: '',
    portalUser: {},
    loginData: {},
    role: {},
  }

  branchesStore.$reset()
  generalStore.resetExceptVersion()
}

export default logout
